(function () {
  var sections = document.querySelectorAll('.oddit-section-social-media-follow');
  if (!sections.length) return;

  for (var s = 0; s < sections.length; s++) {
    initSection(sections[s]);
  }

  function initSection(section) {
    var track = section.querySelector('.oddit-section-social-media-follow__track');
    if (!track) return;

    var prevBtns = section.querySelectorAll('.oddit-section-social-media-follow__arrow--prev');
    var nextBtns = section.querySelectorAll('.oddit-section-social-media-follow__arrow--next');

    var originals = Array.prototype.slice.call(
      track.querySelectorAll('.oddit-section-social-media-follow__card')
    );
    var n = originals.length;
    if (n === 0) return;

    var programmaticScroll = false;
    var scrollEndTimer = null;

    // --- Build a seamless loop: clone a full set before and after the originals.
    // Layout becomes: [clones][originals][clones] so scrollLeft can wrap by one
    // set-width without the user ever seeing an edge.
    if (n > 1) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var c = 0; c < n; c++) {
        before.appendChild(sanitizeClone(originals[c].cloneNode(true)));
        after.appendChild(sanitizeClone(originals[c].cloneNode(true)));
      }
      track.insertBefore(before, originals[0]);
      track.appendChild(after);
    }

    var allCards = track.querySelectorAll('.oddit-section-social-media-follow__card');

    function sanitizeClone(node) {
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('data-oddit-clone', 'true');
      // Strip scroll-reveal so clones are visible immediately (the reveal
      // observer never sees nodes added after init).
      node.classList.remove('oddit-reveal', 'oddit-entrance', 'oddit-section-active');
      node.style.opacity = '';
      node.style.transform = '';
      // Keep cloned interactive elements out of the tab order.
      var focusables = node.querySelectorAll('a, button, [tabindex]');
      for (var f = 0; f < focusables.length; f++) {
        focusables[f].setAttribute('tabindex', '-1');
      }
      return node;
    }

    // Distance between two consecutive cards (card width + gap).
    function getStep() {
      if (allCards.length < 2) {
        return allCards[0] ? Math.round(allCards[0].getBoundingClientRect().width) : 0;
      }
      return Math.round(allCards[1].offsetLeft - allCards[0].offsetLeft);
    }

    // Resting offset of a card from the scrollport's left edge, honouring the
    // active snap alignment: centered on mobile, gutter-aligned (start) on desktop.
    function restOffset() {
      if (!allCards[0]) return 0;
      var snap = getComputedStyle(allCards[0]).scrollSnapAlign || '';
      if (snap.indexOf('center') !== -1) {
        return (track.clientWidth - allCards[0].offsetWidth) / 2;
      }
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft);
      return isNaN(pad) ? 0 : pad;
    }

    // scrollLeft that snaps allCards[domIndex] to its resting position.
    function scrollForCard(domIndex) {
      if (!allCards[domIndex]) return 0;
      return allCards[domIndex].offsetLeft - restOffset();
    }

    // Keep scrollLeft inside the middle (originals) window. Because the three
    // sets are identical, shifting by one set-width is visually seamless.
    function wrap() {
      if (n < 2) return;
      var step = getStep();
      if (!step) return;
      var setWidth = step * n;
      var home = scrollForCard(n); // first original snapped to gutter
      var lower = home - step * 0.5;
      while (track.scrollLeft < lower) track.scrollLeft += setWidth;
      while (track.scrollLeft >= lower + setWidth) track.scrollLeft -= setWidth;
    }

    function navigate(dir) {
      var step = getStep();
      if (!step) return;
      wrap();
      programmaticScroll = true;
      track.scrollTo({ left: track.scrollLeft + dir * step, behavior: 'smooth' });
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(function () {
        programmaticScroll = false;
        wrap();
      }, 450);
    }

    function bind(btns, dir) {
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener('click', function () {
          navigate(dir);
        });
      }
    }
    bind(prevBtns, -1);
    bind(nextBtns, 1);

    track.addEventListener(
      'scroll',
      function () {
        if (programmaticScroll) return;
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(wrap, 80);
      },
      { passive: true }
    );

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        track.scrollLeft = scrollForCard(n);
      }, 120);
    });

    // Initial placement: snap the first original card to the gutter.
    if (n > 1) {
      track.scrollLeft = scrollForCard(n);
    }
  }
})();
